import { render, staticRenderFns } from "./Step2Component.vue?vue&type=template&id=237caf2a&"
import script from "./Step2Component.vue?vue&type=script&lang=js&"
export * from "./Step2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports